export default "__VITE_ASSET__BjIV1chH__"